// 德语
const ge = {
    // 首页-激活说明
    activateExplain: {
        title: 'Aktivieren Sie Ihre erweiterte Garantie und erhalten Sie das besondere Geschenk für Sie',
        desp: 'Angewandte Bedingung: Um sich zu qualifizieren, erklären sich die Kunden damit einverstanden, ihr Einkaufserlebnis mit den gekauften Produkten zu teilen, die seit mindestens einer Woche aktiv verwendet werden.',
        conditions: [
            'Nur für Kunden, die die Produkte auf Amazon gekauft haben.',
            'Jeder Kunde kann nur ein KOSTENLOSES GESCHENK für ein Produkt anfordern. (Das heißt, egal wie oft Sie dasselbe Produkt kaufen, Sie können nur ein KOSTENLOSES Geschenk erhalten).',
        ]
    },
    // 首页-激活表单
    activateForm: {
        title: 'Aktivieren Sie Ihre erweiterte Garantie und erhalten Sie JETZT das KOSTENLOSE Geschenk!',
        desp: 'Nur für bestehende Kunden verfügbar',
        name: 'Name',
        namePlaceholder: `Geben Sie den Namen des Empfängers ein`,
        nameErrMsg: `Name ist falsch.`,
        email: 'E-Mail',
        emailPlaceholder: `Geben Sie Ihre E-Mail-Adresse ein`,
        emailErrMsg: `E-Mail ist falsch.`,
        verifCode: 'Verifizierungs-Schlüssel',
        verifCodePlaceholder: `Geben Sie Ihren Bestätigungs-Code ein`,
        verifCodeErrMsg: `Falscher verifikationscode.`,
        btnSendCode: `Senden Sie den Bestätigungscode`,
        countdownMsg: `In {countdown} Sekunden erneut senden`,
        orderId: 'Bestellnummer',
        orderIdPlaceholder: `Geben Sie Ihre Bestellnummer ein`,
        orderIdErrMsg: `Bestellnummer ist falsch.`,
        orderAppliedError: `Diese Bestellung hat bereits ein Geschenk beantragt.`,
        skuAppliedError: `Das Geschenk dieser Bestellung wurde abgeholt.`,
        orderIdHelp: 'Wie finde ich meine Bestellnummer?',
        btnAactivate: 'Jetzt aktivieren',
        statement: 'Wir werden Ihre persönlichen Daten sicherlich nicht an Dritte weitergeben.',
        orderIdErrPopoverMsg: 'Wenn Ihre Bestellnummer sicher korrekt ist, wenden Sie sich bitte per E-Mail an unseren Kundenservice. Wir helfen Ihnen, die erweiterte Garantie zu aktivieren und zu bestätigen, ob die Veranstaltung Ihren Markt abdeckt.',
        priceErrPopoverMsg: 'Es tut uns sehr leid, Ihnen mitteilen zu müssen, dass für diese Bestellung unser niedrigster Rabatt verwendet wurde. Bei Problemen können Sie uns gerne eine E-Mail senden.'
    },
    // 通用弹框
    commonModal: {
        msg: `{msg}`,
        msgContents: [
            `Der Name des Empfängers kann nicht mit der Bestellung übereinstimmen`,
            `Ob die Überprüfung von Amazon abgeschlossen ist?`,
            `Möchten Sie weiterhin zu Amazon gehen, um zu überprüfen?`
        ],
        btnRewrite: 'Umschreiben',
        btnNo: 'NEIN',
        btnYes: 'JA'
    },
    // 选择礼物
    chooseGift: {
        title: 'Wählen Sie nun das gewünschte Geschenk.',
        modalTitle: 'Das von Ihnen ausgewählte Geschenk ist leider nicht mehr verfügbar. Bitte wählen Sie es erneut aus',
        btnWant: 'Ich will es',
        btnStockout: 'Ausverkauft'
    },
    // 订单信息
    orderInfo: {
        title: 'Glückwunsch! Ihre erweiterte Garantie ist aktiviert!',
        desp: 'Was Sie bekommen werden',
        orderTitle: 'Ihre Bestellinformationen',
        orderId: 'Auftragsnummer',
        productASIN: 'Produkt ASIN',
        productName: 'Produktname',
        address: 'Adresse',
        aboutGift: [
            'Über das Geschenk',
            'KEINE Versandkosten, KEINE versteckten Gebühren, KEINE Kreditkarte erforderlich',
            '4 einfache Schritte, um es zu bekommen (weniger als 5 Minuten).',
            'Das Geschenk wird Ihnen innerhalb von 2-5 Werktagen nach Ihrer Inanspruchnahme zugesandt.'
        ],
        btnWant: 'Ich will es'
    },
    // 步骤1
    stepOne: {
        title: 'Schritt 1 von 4: Eine kurze Umfrage über Ihren Kauf.',
        questionList: [{
                id: 1,
                select_type: 'radio',
                name: 'sex',
                title: '1. Ich bin ein…?',
                option: [{
                        txt: 'Weiblich',
                        value: 0
                    },
                    {
                        txt: 'Männlich',
                        value: 1
                    },
                    {
                        txt: 'Nicht sicher',
                        value: 2
                    }
                ]
            },
            {
                id: 2,
                select_type: 'radio',
                name: 'age',
                title: `2. Was ist deine Altersspanne?`,
                option: [{
                        txt: 'Weniger als 20',
                        value: 0
                    },
                    {
                        txt: '20-30',
                        value: 1
                    },
                    {
                        txt: '30-40',
                        value: 2
                    },
                    {
                        txt: '40-50',
                        value: 3
                    },
                    {
                        txt: '50-60',
                        value: 4
                    },
                    {
                        txt: 'Mehr als 60',
                        value: 5
                    }
                ]
            },
            {
                id: 3,
                select_type: 'radio',
                name: 'reason',
                title: '3. Warum hast du uns gewählt?',
                option: [{
                        txt: 'Marke',
                        value: 0
                    },
                    {
                        txt: 'Design',
                        value: 1
                    },
                    {
                        txt: 'Preis',
                        value: 2
                    },
                    {
                        txt: 'Eigenschaften',
                        value: 3
                    },
                    {
                        txt: 'Bewertungen',
                        value: 4
                    },
                    {
                        txt: 'Andere Gründe',
                        value: 5,
                        placeholder: 'Bitte geben Sie einen Grund ein'
                    }
                ]
            },
        ],
        btnNext: 'nächster Schritt'
    },
    // 步骤2
    stepTwo: {
        title: 'Schritt 2 von 4: Teilen Sie uns Ihre Erfahrungen mit dem Produkt mit.',
        despOne: `Gesamtbewertung?`,
        despTwo: `Lassen Sie uns wissen, wie unsere Produkte für Sie funktionieren.`,
        notice: `(Bitte geben Sie mindestens 10 Zeichen ein)`,
        commentPlaceholder: 'Geben Sie Ihren Kommentar ein',
        commentErrMsg: `Kommentarwörter dürfen 20.000 nicht überschreiten`,
        btnNext: 'nächster Schritt',
        btnPrev: 'vorheriger Schritt'
    },
    // 步骤3
    stepThree: {
        title: 'Schritte 3 von 4: Teilen Sie Ihr Einkaufserlebnis mit anderen.',
        desp: 'NUR dauert Sie ein paar Sekunden. Ihre Kommentare würden anderen Kunden helfen, eine bessere Kaufentscheidung zu treffen. Vielen Dank für Ihr Verständnis und Ihre Unterstützung.',
        commentTitle: 'Deine Kommentare',
        defaultComment: 'Ich mag Ihr Produkt sehr!',
        btnCopyPost: 'Klicken Sie hier, um Ihre Amazon-Rezension zu kopieren und zu veröffentlichen'
    },
    // 步骤4
    stepFour: {
        title: 'Schritt 4 von 4: Bestätigen Sie Ihre Adresse.',
        desp: 'Was Sie bekommen werden',
        fullName: 'Vollständiger Name',
        fullNamePlaceholder: `Geben Sie Ihren vollständigen Namen ein`,
        fullNameErrMsg: `Der vollständige Name ist falsch`,
        phone: 'Telefon',
        phonePlaceholder: `Geben Sie Ihr Telefon ein`,
        phoneErrMsg: `Telefon ist falsch`,
        email: 'E-Mail',
        emailPlaceholder: `Geben Sie Ihre E-Mail-Adresse ein`,
        emailErrMsg: `E-Mail ist falsch`,
        address: 'Adresse',
        addressPlaceholder: `Geben Sie Ihre Adresse ein`,
        addressErrMsg: `Adresse ist falsch`,
        streetPlaceholder:`Adresse`,
        apartmentPlaceholder:`Wohnungseinheit`,
        cityPlaceholder:`Stadt`,
        regionPlaceholder: `Staat wählen`,
        countryPlaceholder: `Wähle ein Land`,
        postcode: 'Postleitzahl',
        postcodePlaceholder: `Geben Sie Ihre Postleitzahl ein`,
        postcodeErrMsg: `Postleitzahl ist falsch`,
        btnComfirm: 'COMFIRM'
    },
    // 完成礼物申请
    completeApplication: {
        title: `Sie haben den kostenlosen Geschenkantrag abgeschlossen`,
        msgs: [
            'Das kostenlose Geschenk wird innerhalb von 2-5 Werktagen versendet.',
            'Das kostenlose Geschenk wird innerhalb von 2-5 Werktagen an Ihre E-Mail-Adresse ',
            ' gesendet.Mit freundlichen Grüßen, danke für den Kauf unserer Produkte, dann wird es einen engagierten After-Sales-Team-Kontakt geben.',
            'Bei weiteren Problemen wenden Sie sich bitte per E-Mail an unseren Kundenservice oder besuchen Sie unsere offizielle Website.',
            'Da Sie mit unseren Produkten nicht 100% zufrieden sind, können Sie sich per E-Mail an unseren Kundenservice wenden oder unsere offizielle Website besuchen. Es werden Fachleute für Sie da sein. 100% Kundenzufriedenheit ist unsere Garantie!'
        ],
        btnComfirm: 'Bestätigen'
    },
    // 获取订单号指导
    guide: {
        title: 'Wie finde ich meine Bestellnummer?',
        desps: [
            `Schritt 1: Melden Sie sich bei Ihrem Amazon-Konto an und klicken Sie auf der Seite "Konto und Listen" auf "Ihre Bestellung"`,
            `Schritt 2: Klicken Sie bei der richtigen Bestellung auf "Bestelldetails"`,
            `Schritt 3: Sie sehen Ihre Bestellnummer`
        ],
        btnOK: 'okay'
    }
}

export default ge